import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import { uomLoader } from "shared/loaders"

import { CustomerPurchaseOrdersTab } from "@/screens/CustomerOrders/components/CustomerPurchaseOrdersTab/CustomerPurchaseOrdersTab"
import { customerPurchaseOrderSearchSchema } from "@/screens/CustomerOrders/schemas"

export const Route = createFileRoute("/app/orders/$companyId/$shipToLocationId/_layout/customer-purchase-orders")({
  validateSearch: zodValidator(customerPurchaseOrderSearchSchema),
  loader: uomLoader,
  component: CustomerPurchaseOrdersTab,
})
